export enum LoginAnalyticsEnum {
  LOGIN_VIEW_MODAL = '[PAC WEB] Login - Modal visualizada',
  LOGIN_CLICK_SUBMIT = '[PAC WEB] Login - Clicou em "Entrar"',
  LOGIN_SUCCESS = '[PAC WEB] Login - Login com sucesso',
  LOGIN_ERROR = '[PAC WEB] Login - Erro de login',
  LOGIN_INVALID_CPF = '[PAC WEB] Login - CPF inválido',
  LOGIN_INVALID_PASSWORD = '[PAC WEB] Login - Senha inválida',
  LOGIN_CLICK_FORGOT_PASSWORD = '[PAC WEB] Login - Clicou em "Esqueci minha senha"',
  LOGIN_CLICK_REGISTER = '[PAC WEB] Login - Clicou em "Cadastre-se"',
  LOGIN_CLOSE_MODAL = '[PAC WEB] Login - Fechou modal',
  SIGNUP_VIEW_PAGE = '[PAC WEB] Login - Cadastro - Página visualizada',
  SIGNUP_CLICK_CREATE_ACCOUNT = '[PAC WEB] Login - Cadastro - Clicou em "Criar conta"',
  SIGNUP_CODE_SENT = '[PAC WEB] Login - Cadastro - Código enviado',
  SIGNUP_ERROR = '[PAC WEB] Login - Cadastro - Erro ao criar conta',
  SIGNUP_ACCOUNT_CREATED = '[PAC WEB] Login - Cadastro - Conta criada',
  PENDING_EMAIL_CODE_REQUESTED = '[PAC WEB] Login - E-mail pendente - Código solicitado',
  PENDING_EMAIL_CONFIRMED = '[PAC WEB] Login - E-mail pendente - E-mail confirmado',
  VERIFICATION_CODE_INVALID = '[PAC WEB] Login - Código de verificação - Código inválido',
  VERIFICATION_CODE_CLICK_RESEND = '[PAC WEB] Login - Código de verificação - Clicou em "Reenviar"',
  PASSWORD_RECOVERY_EMAIL_SENT = '[PAC WEB] Login - Recuperar senha - E-mail enviado',
  PASSWORD_RECOVERY_EMAIL_ERROR = '[PAC WEB] Login - Recuperar senha - Erro ao enviar e-mail',
  PASSWORD_RECOVERY_VIEW_PAGE = '[PAC WEB] Login - Recuperar senha - Página visualizada',
  PASSWORD_RECOVERY_PASSWORD_RESET = '[PAC WEB] Login - Recuperar senha - Senha redefinida',
  PASSWORD_RECOVERY_RESET_ERROR = '[PAC WEB] Login - Recuperar senha - Erro ao redefinir senha',
}

export enum LoginErrorType {
  CREDENCIAIS_INVALIDAS = 'credenciais_invalidas',
  SERVIDOR = 'servidor',
}

export enum VerificationCodeFlow {
  CADASTRO = 'cadastro',
  EMAIL_PENDENTE = 'email_pendente',
}

export enum PasswordRecoveryEmailErrorType {
  CPF_NAO_ENCONTRADO = 'cpf_nao_encontrado',
  SERVIDOR = 'servidor',
}

export enum RecoveryLinkStatus {
  VALIDO = 'valido',
  EXPIRADO = 'expirado',
  INVALIDO = 'invalido',
}

export enum PasswordResetErrorType {
  SENHA_REPETIDA = 'senha_repetida',
  LINK_INVALIDO = 'link_invalido',
  SERVIDOR = 'servidor',
}

export enum LoginOriginEnum {
  HEADER = 'header',
  HELP_CENTER = 'help_center',
  ENTITY = 'entity',
  PASSWORD_RECOVERY = 'password_recovery',
  SEARCH_RESULT = 'search_result',
  PROTECTED_PAGE = 'protected_page',
  SESSION_EXPIRED = 'session_expired',
}
